import { render, staticRenderFns } from "./ShopifyThemeSettings.vue?vue&type=template&id=2d1f310d&"
import script from "./ShopifyThemeSettings.vue?vue&type=script&lang=ts&"
export * from "./ShopifyThemeSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ShopifyThemeSettings.vue?vue&type=style&index=0&id=2d1f310d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports